import { gqlVmToCommonVm } from "@/admin/vm/gqlToCommonVm.ts";
import { modifyVmMutation, resizeDiskMutation } from "@/admin/vm/vmQuery.ts";
import type { GQVmItem } from "@/admin/vm/VmsTable.tsx";
import { WModalButton } from "@/components/button/WToolButton.tsx";
import { WModal } from "@/components/modal/WModal.tsx";
import { useStandardMutation } from "@/modules/api/useStandardMutation.ts";
import { getPrimaryStorage } from "@/modules/compute/vmEntityUtils.ts";
import { BaseResizeModal } from "@/modules/compute/VmResizeModal.tsx";

export function VmResizeToolbarButton(props: VmResizeModalProps) {
    const isDeleted = props.item.status === "deleted";
    return (
        <WModal button={<WModalButton label="Resize" isDisabled={isDeleted} icon="jp-expand-2-icon" />}>
            <VmResizeModalContent {...props} />
        </WModal>
    );
}

export interface VmResizeModalProps {
    item: GQVmItem;
}

function VmResizeModalContent({ item }: VmResizeModalProps) {
    //#region Hooks
    const vmMutation = useStandardMutation(modifyVmMutation);
    const diskMutation = useStandardMutation(resizeDiskMutation);
    const vm = gqlVmToCommonVm(item);
    const primary = getPrimaryStorage(vm);
    //#endregion

    return (
        <BaseResizeModal
            vm={vm}
            onResize={async (params) => {
                if (vm.vcpu !== params.vm.vcpu || item.memory !== params.vm.ram) {
                    await vmMutation.mutateAsync({ body: params.vm, location: vm.location });
                }

                if (params?.disk && primary?.size !== params?.disk?.size_gb) {
                    await diskMutation.mutateAsync({ body: params.disk, location: vm.location });
                }
                //await mutation.mutateAsync({ vm, body: params, location: vm.location });
            }}
        />
    );
}
